// Holds an in-progress profile edit that could not be saved because the
// session had ended, so a reload or a trip to the sign-in page does not
// destroy what the customer typed.
//
// The primary protection against losing work is that a session-expired
// 401 no longer unmounts EditProfile -- the form stays on screen with
// everything in it (see the SESSION_EXPIRED case in
// reducers/registerUser.js, which deliberately leaves isAuth alone).
// This is the second line: it survives a refresh, a service-worker
// reload, or navigating away and back.
//
// sessionStorage, not localStorage: this is one tab's unsaved work, and
// it should not outlive the tab. Cleared as soon as a save succeeds.
const KEY = 'dcc.pendingProfileEdit';

const store = () => {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return null;
    return window.sessionStorage;
  } catch (err) {
    return null;
  }
};

export const savePendingProfileEdit = (payload) => {
  const s = store();
  if (!s || !payload) return;
  try {
    // Never the password fields. They are transient by nature, the
    // customer can retype them, and writing them to storage would be a
    // gratuitous place for a credential to sit.
    const { curpassword, newpassword, ...safe } = payload;
    s.setItem(KEY, JSON.stringify(safe));
  } catch (err) {
    /* quota or privacy mode -- the on-screen form is still intact */
  }
};

export const loadPendingProfileEdit = () => {
  const s = store();
  if (!s) return null;
  try {
    const raw = s.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
};

export const clearPendingProfileEdit = () => {
  const s = store();
  if (!s) return;
  try {
    s.removeItem(KEY);
  } catch (err) {
    /* ignore */
  }
};
